export const s3 = {
  state: {
    s3Url: null,
    fileDetails: {},
    s3Uploading: false,
    dataLoaded: false
  },
  mutations: {
    SET_s3Url(state, s3Url) {
      state.s3Url = s3Url;
    },
    CLEAR_File(state) {
      state.s3Url = null;
      state.fileDetails = {};
      state.s3Uploading = false;
      state.dataLoaded = false;
    },
    SET_fileDetails(state, fileDetails) {
      state.fileDetails = fileDetails;
    },
    SET_s3Uploading(state, s3Uploading) {
      state.s3Uploading = s3Uploading;
    },
    SET_dataLoaded(state, s3Uploading) {
      state.dataLoaded = s3Uploading;
    }
  },
  actions: {
    setS3Url: ({ commit, state }, newValue) => {
      commit('SET_s3Url', newValue)
      return state.s3Url
    },
    clearFile: ({ commit }) => {
      commit('CLEAR_File')
    },
    setFileDetails: ({ commit, state }, newValue) => {
      commit('SET_fileDetails', newValue)
      return state.fileDetails
    },
    setS3Uploading: ({ commit, state }, newValue) => {
      commit('SET_s3Uploading', newValue)
      return state.s3Uploading
    },
    setDataLoaded: ({ commit, state }, newValue) => {
      commit('SET_dataLoaded', newValue)
      return state.dataLoaded
    },
  },
  getters: {
    s3Url: (state) => {
      return state.s3Url
    },
    fileDetails: (state) => {
      return state.fileDetails
    },
    s3Uploading: (state) => {
      return state.s3Uploading
    },
    dataLoaded: (state) => {
      return state.dataLoaded
    },
  }
};